import { defineAsyncComponent } from 'vue'
const IslandRenderer = import.meta.server ? defineAsyncComponent(() => import("/app/node_modules/.pnpm/nuxt@4.5.2_6210b4614a90d24ed7187407524aa20b/node_modules/nuxt/dist/app/components/island-renderer").then(r => r.default || r)) : () => null
export default IslandRenderer